/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type missionControlHeader_viewer = {
    readonly email: string | null;
    readonly actualPersonId: string | null;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly company: {
        readonly id: string;
        readonly name: string | null;
    } | null;
    readonly " $refType": "missionControlHeader_viewer";
};
export type missionControlHeader_viewer$data = missionControlHeader_viewer;
export type missionControlHeader_viewer$key = {
    readonly " $data"?: missionControlHeader_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"missionControlHeader_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "missionControlHeader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '5a8babfac87e7540c29cbed1ade689fd';
export default node;
